// src/Layout/Header/SearchBar.jsx
const SearchBar = () => (
  <div className="flex items-center gap-2 bg-gray-50 border border-transparent rounded-full px-4 py-2 w-56 hover:border-gray-300 transition-colors">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2">
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
    <input
      type="text"
      placeholder="Search for anything..."
      className="bg-transparent text-sm text-gray-600 placeholder-gray-400 outline-none w-full"
    />
  </div>
);

export default SearchBar;